// extracted by mini-css-extract-plugin
module.exports = {"headerText":"TheFamily_headerText__-DmwH","werkplekHeader":"TheFamily_werkplekHeader__3INM8","werkplekText":"TheFamily_werkplekText__2tIgh"};